import { cn } from "@ui/lib";
import Image from "next/image";

export function Logo({
	withLabel = true,
	className,
}: {
	className?: string;
	withLabel?: boolean;
}) {
	return (
		<span
			className={cn(
				"flex items-center font-semibold text-foreground leading-none",
				className,
			)}
		>
			<Image
				src="/images/logo.webp"
				alt="ImagePrompt CO Logo"
				width={30}
				height={30}
				style={{ height: "auto", width: "auto", maxWidth: "30px" }}
				className="object-contain"
			/>
			{withLabel && (
				<span className="ml-2 hidden text-lg md:block bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
					ImagePrompt.co
				</span>
			)}
		</span>
	);
}
